import { Component, Vue, Prop } from 'vue-property-decorator';
import { CreateElement } from 'vue';

@Component
export default class ClAmbientProgress extends Vue {
  @Prop({
    type: String,
    default: '28px'
  })
  readonly height!: string;

  @Prop({
    type: String,
    default: '100%'
  })
  readonly width!: string;

  @Prop(String)
  readonly borderRadius!: string;

  render(h: CreateElement) {
    return (
      <div
        class="cl-ambient-progress"
        style={{
          height: this.height,
          width: this.width,
          borderRadius: this.borderRadius
        }}
      />
    );
  }
}
